import React, {
  createContext,
  useContext,
  useCallback,
  useEffect,
  useState
} from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import api from '~/services/api';
import { toast } from "react-toastify";


const PendencyContext = createContext();

export function PendencyProvider({ children }) {
  const {codeStore} = useSelector(state => state.userReducer.response);
  const history = useHistory()
  const location = useLocation()
  const [pendencySelected, setPendencySelected] = useState(null)
  const [pendencies, setPendencies] = useState([])
  const [numberOfPendingIssues, setNumberOfPendingIssues] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleGetPendenciesList = useCallback(async () => {
    let cleanUp = false

    try{

      const parameters = {
      headers: {
        method: "GET",
        access_token: localStorage.getItem("access_token"),
      },
      params: {
       "store-id": localStorage.getItem("storeId"),
       phase: 'AGUARDANDO_RETORNO_DO_REVENDEDOR',
      }
    };
      const {data} = await api.get('/industrial/case/v1/cases-sf', parameters)

      if(cleanUp)return
      setLoading(false)
      setPendencies(data)
      setNumberOfPendingIssues(data.length)
    }catch{
      setLoading(false)
      setPendencies([])
      setNumberOfPendingIssues(0)
    }
    return () => cleanUp = true

  }, [api, setLoading, setPendencies, setNumberOfPendingIssues ])
  useEffect(()=>{
    handleGetPendenciesList()
  },[codeStore])

  useEffect(() => {
    if(!loading){
      setNumberOfPendingIssues(pendencies.length)

      if(location.pathname === '/pendencias' && pendencies.length === 0 ){
        history.push('/portal')
      }
    }

  },[pendencies])

  const handlePendency = useCallback((isResolvedPendency = false) => {
    if(isResolvedPendency){
      setPendencies(sta => sta.filter(pendency =>  pendency.id !== pendencySelected.id))
    }
    setPendencySelected(null)

  }, [ setPendencySelected, setPendencies, pendencySelected ])

  return (
    <PendencyContext.Provider
      value={{
        handlePendency,
        pendencySelected,
        pendencies,
        numberOfPendingIssues,
        loading,
        setPendencySelected
      }}
    >
      {children}
    </PendencyContext.Provider>
  );
}

export function usePendency() {
  const context = useContext(PendencyContext);

  if (!context) {
    throw new Error(
      'usePendency deve ser usado dentro do PendencyProvider',
    );
  }

  return context;
}
